import styled, { keyframes, css } from 'styled-components'

const cascadeAnimation = keyframes`
  0%, 100% {
    opacity: 0.32;
    transform: scaleX(0.92) scaleY(0.92);
    filter: drop-shadow(0 0 0 rgba(0, 0, 0, 0));
  }
  30% {
    opacity: 1;
    transform: scaleX(1.06) scaleY(1.06);
    filter: drop-shadow(0 2px 6px rgba(0, 0, 0, 0.12));
  }
  65% {
    opacity: 0.55;
    transform: scaleX(0.98) scaleY(0.98);
  }
`

const textPulseAnimation = keyframes`
  0%, 100% {
    opacity: 0.65;
  }
  50% {
    opacity: 1;
  }
`

export interface OrdenoLoadingStyleProps {
  $variant?: 'inline' | 'card' | 'overlay' | 'fullscreen'
  $size?: 'sm' | 'md' | 'lg'
}

export const LoadingWrapper = styled.div<OrdenoLoadingStyleProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${(props) => (props.$size === 'sm' ? '0.35rem' : props.$size === 'lg' ? '0.75rem' : '0.55rem')};
  user-select: none;

  ${(props) =>
    props.$variant === 'fullscreen' &&
    css`
      position: fixed;
      inset: 0;
      width: 100vw;
      height: 100vh;
      z-index: 9999;
      background: rgba(248, 250, 252, 0.45);
      backdrop-filter: blur(6px);
      -webkit-backdrop-filter: blur(6px);
    `}

  ${(props) =>
    props.$variant === 'overlay' &&
    css`
      position: absolute;
      inset: 0;
      width: 100%;
      height: 100%;
      z-index: 20;
      background: rgba(255, 255, 255, 0.75);
      backdrop-filter: blur(2px);
      -webkit-backdrop-filter: blur(2px);
    `}

  ${(props) =>
    props.$variant === 'card' &&
    css`
      padding: 1.5rem 2rem;
      background-color: #ffffff;
      border-radius: 1rem;
      box-shadow: 0 4px 24px rgba(0, 0, 0, 0.07), 0 1px 4px rgba(0, 0, 0, 0.04);
      border: 1px solid rgba(226, 232, 240, 0.8);
    `}
`

export const CardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  padding: 1.4rem 1.8rem;
  background-color: #ffffff;
  border-radius: 1rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.08), 0 1px 3px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(226, 232, 240, 0.85);
`

export const SvgContainer = styled.svg<{ $size?: 'sm' | 'md' | 'lg' }>`
  width: ${(props) => (props.$size === 'sm' ? '26px' : props.$size === 'lg' ? '48px' : '36px')};
  height: ${(props) => (props.$size === 'sm' ? '23px' : props.$size === 'lg' ? '42px' : '32px')};
  overflow: visible;

  .bar-top {
    transform-origin: 36px 3.75px;
    animation: ${cascadeAnimation} 1.3s cubic-bezier(0.4, 0, 0.2, 1) infinite 0s;
  }

  .bar-middle {
    transform-origin: 36px 15.75px;
    animation: ${cascadeAnimation} 1.3s cubic-bezier(0.4, 0, 0.2, 1) infinite 0.22s;
  }

  .bar-bottom {
    transform-origin: 36px 27.75px;
    animation: ${cascadeAnimation} 1.3s cubic-bezier(0.4, 0, 0.2, 1) infinite 0.44s;
  }
`

export const LoadingText = styled.span<{ $size?: 'sm' | 'md' | 'lg' }>`
  font-size: ${(props) => (props.$size === 'sm' ? '0.7rem' : props.$size === 'lg' ? '0.86rem' : '0.78rem')};
  font-weight: 500;
  color: #475569;
  letter-spacing: 0.015em;
  animation: ${textPulseAnimation} 2s ease-in-out infinite;
`
